import { ComponentClass, createElement, forwardRef, FunctionComponent, memo, ReactNode } from "react";
import classNames from "classnames";
import { Link as RouterLink } from "react-router";

import styles from "./style.module.scss";

export type LinkProps = {
  disabled?: boolean,
  className?: string,
  children?: ReactNode,
  component?: string | FunctionComponent<any> | ComponentClass<any>,
  style?: object,
  linkType?: "s" | "m" | "l",
  [key: string]: any
};

export const Link = memo<LinkProps>(forwardRef((
  {
    disabled = false,
    className,
    children,
    component = RouterLink,
    style,
    linkType = "m",
    ...restProps
  }, ref) => {
  return (
    createElement(
      component as any,
      {
        tabIndex: disabled ? -1 : 0,
        disabled,
        style,
        className: classNames(
          className,
          "mimic-link",
          styles.link,
          {
            [styles[linkType as any]]: true,
            [styles.disabled]: disabled,
          },
        ),
        ref,
        "data-link-type": linkType,
        "data-disabled": disabled,
        ...restProps,
      },
      typeof children === "string" ? <span>{children}</span> : children,
    )
  );
}));

export default Link;
